import { toast } from "sonner";
import type { ApiErrorEnvelope } from "@/shared/types/apiError";

export type ToastSeverity = "warning" | "error" | "neutral";

export interface ShowErrorToastOptions {
  severity: ToastSeverity;
  /** Auto-dismiss in ms; pass Number.POSITIVE_INFINITY for manual-only dismiss. */
  durationMs: number;
  /** Stable key to deduplicate identical toasts within a short window. */
  dedupKey?: string;
}

/**
 * Shows an error toast for an envelope. Title is the userMessage, body is the
 * nextStep when present. Severity drives color (4xx amber → warning, 5xx red →
 * error, network → neutral). Per the user's choice, traceId is not displayed —
 * support correlates via timestamp + user.
 */
export const showErrorToast = (envelope: ApiErrorEnvelope, opts: ShowErrorToastOptions) => {
  const fn = severityToToastFn(opts.severity);
  fn(envelope.userMessage, {
    description: envelope.nextStep ?? undefined,
    duration: opts.durationMs,
    id: opts.dedupKey,
  });
};

const severityToToastFn = (severity: ToastSeverity) => {
  switch (severity) {
    case "error":
      return toast.error;
    case "warning":
      return toast.warning;
    case "neutral":
    default:
      return toast.message;
  }
};
